import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../../../components/layout';
import { ResolutionHeader, resolution_status } from '../../../components/resolution';
import { wsdcc_action, wsdcc_issue, WsdccHeader } from '../../../components/wsdcc';
export const file = `R-90`;
export const title = `Vote "Approve" on Referendum 90 (SB5395)`;
export const title_short = `Approve Referendum 90`;
export const minutes_date = `2020-08-12`;
export const status = resolution_status.adopted;
export const wsdcc_header = {
  action_date: minutes_date,
  number: 2,
  organization: '',
  title_short,
  wsdcc_action: wsdcc_action.submitted,
  wsdcc_issue: wsdcc_issue.education
};
export const r = {
  file,
  minutes_date,
  status,
  title
};
export const _frontmatter = {};
const layoutProps = {
  file,
  r,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Layout mdxType="Layout">
      <WsdccHeader w={wsdcc_header} mdxType="WsdccHeader" />
      <ResolutionHeader r={r} mdxType="ResolutionHeader" />
      <p><strong parentName="p">{`Whereas`}</strong>{` age-appropriate, comprehensive and inclusive sex education is critical to the health
and safety of Washington’s young people, both short-term and long-term; and`}</p>
      <p><strong parentName="p">{`Whereas`}</strong>{` LGBTQ+ young people need sex education that addresses their identities and
experiences, and that provides all young people with opportunities to understand sexual
orientation and gender identity in open, non-stigmatizing ways; and`}</p>
      <p><strong parentName="p">{`Whereas`}</strong>{` young people need access to information and resources that include the importance of
consent and healthy relationships – starting well before young adulthood and well before they
become sexually active – to help them understand how to ask for consent, respect personal
boundaries, and learn how to utter and accept a “No”; and`}</p>
      <p><strong parentName="p">{`Whereas`}</strong>{` a strong majority of Washingtonians support requiring schools to offer scientifically
based, medically accurate, age-appropriate, comprehensive sex education (86% support, 70%
“strongly support,” according to Planned Parenthood Votes Northwest); and`}</p>
      <p><strong parentName="p">{`Whereas`}</strong>{` Senate Bill 5395, formalizing provisions regarding “Comprehensive Sexual Health
Education” – but without change or compromise to the substance of the existing guidelines in the
Washington State Health and Physical Education K-12 Learning Standards – was passed by our
state legislature and signed into law by Governor Inslee in March 2020, with the support of
Superintendent of Public Instruction Chris Reykdal; and`}</p>
      <p><strong parentName="p">{`Whereas`}</strong>{` SB 5395 would require school districts to adopt or develop, consistent with state
standards, comprehensive age-appropriate sexual health education, as defined, for all students,
and excuse students if their parents request;`}</p>
      <p><strong parentName="p">{`Therefore, be it resolved`}</strong>{` that the Salish Sea Chapter of the WA State Federation of Democratic
Women urges all voters to vote “Approve” on Referendum 90 (SB 5395) in the November 2020
election, in order to assure the availability of age-appropriate, comprehensive, scientifically
based, inclusive sex education that varies by grade level, and includes affirmative consent and
bystander training; K-3 instruction would only be social-emotional learning for students in
Washington.`}</p>
      <hr></hr>
      <p>{`Adopted by the Salish Sea Chapter of the Washington State Federation of Democratic Women
(WSFDW) on July 27, 2020.`}</p>
    </Layout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      